import ReactDOMServer from 'react-dom/server';

const ContactUsMessageLayout = ({ data }) => {
  const { name, mobileNumber, emailAddress, message, textAgree } = data;

  const containerStyle = {
    fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
    color: '#333333',
    backgroundColor: '#f9f9f9',
    padding: '30px',
    borderRadius: '8px',
    maxWidth: '600px',
    margin: '20px auto',
    border: '1px solid #dddddd',
  };

  const headingStyle = {
    fontSize: '20px',
    color: '#111111',
    marginBottom: '10px',
  };

  const introTextStyle = {
    fontSize: '16px',
    lineHeight: '1.6',
    marginBottom: '25px',
  };

  const hrStyle = {
    border: 'none',
    borderTop: '1px solid #eeeeee',
    margin: '25px 0',
  };

  const detailItemStyle = {
    fontSize: '15px',
    marginBottom: '12px',
    lineHeight: '1.5',
  };

  const labelStyle = {
    fontWeight: 'bold',
    color: '#555555',
  };

  const messageBlockStyle = {
    backgroundColor: '#ffffff',
    border: '1px solid #e9e9e9',
    padding: '15px',
    borderRadius: '4px',
    marginTop: '5px',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
  };

  const content = (
    <div style={containerStyle}>
      <h2 style={headingStyle}>Contact Us Form Submission</h2>
      <p style={introTextStyle}>
        The following information was submitted through the website's contact form.
      </p>
      <hr style={hrStyle} />
      <div style={detailItemStyle}>
        <span style={labelStyle}>Name:</span> {name}
      </div>
      <div style={detailItemStyle}>
        <span style={labelStyle}>Phone Number:</span> {mobileNumber || 'N/A'}
      </div>
      <div style={detailItemStyle}>
        <span style={labelStyle}>Email Address:</span> {emailAddress}
      </div>
      <div style={detailItemStyle}>
        <span style={labelStyle}>User Agreed to Receive SMS:</span> {textAgree ? 'Yes' : 'No'}
      </div>
      <div style={detailItemStyle}>
        <span style={labelStyle}>Message:</span>
        <div style={messageBlockStyle}>{message}</div>
      </div>
      <hr style={hrStyle} />
      <p style={{ fontSize: '12px', color: '#777777', textAlign: 'center', marginTop: '30px' }}>
        This is an automated message. Please do not reply directly to this email.
      </p>
    </div>
  );

  return ReactDOMServer.renderToStaticMarkup(content);
};

export default ContactUsMessageLayout;
